export default __webpack_public_path__ + "assets/logo.edcbfa75d9cf95a6fe9c7ea781aee225.svg";